import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import mockupData from "../../database-mockup.json";
import Main from "../../components/main/Main";

function ArticleList() {
  const [homePosts, setHomePosts] = useState([]);
  const [foodPosts, setFoodPosts] = useState([]);
  const [beveragePosts, setBeveragePosts] = useState([]);
  const [holidaysPosts, setHolidaysPosts] = useState([]);
  const [DIYPosts, setDIYPosts] = useState([]);
  const [gardeningPosts, setGardeningPosts] = useState([]);
  const [cleaningPosts, setCleaningPosts] = useState([]);

  const category = useLocation().search;

  // Create a URLSearchParams object with the query string
  const params = new URLSearchParams(category);

  // Get the value of the "category" parameter
  const categoryValue = params.get("category");

  const posts = mockupData.postData;
  const updatePostsByCategory = (postItem) => {
    console.log("check: ", postItem.category);
    switch (postItem.category) {
      case "home":
        setHomePosts((prev) => {
          if (!prev.some((post) => post.id === postItem.id)) {
            return [...prev, postItem];
          }
          return prev; // Return the unchanged state if the post already exists
        });
        break;

      case "food":
        setFoodPosts((prev) => {
          if (!prev.some((post) => post.id === postItem.id)) {
            return [...prev, postItem];
          }
          return prev;
        });
        console.log(foodPosts);
        break;

      case "beverage":
        setBeveragePosts((prev) => {
          if (!prev.some((post) => post.id === postItem.id)) {
            return [...prev, postItem];
          }
          return prev;
        });
        break;

      case "holidays":
        setHolidaysPosts((prev) => {
          if (!prev.some((post) => post.id === postItem.id)) {
            return [...prev, postItem];
          }
          return prev;
        });
        break;

      case "DIY":
        setDIYPosts((prev) => {
          if (!prev.some((post) => post.id === postItem.id)) {
            return [...prev, postItem];
          }
          return prev;
        });
        break;

      case "gardening":
        setGardeningPosts((prev) => {
          if (!prev.some((post) => post.id === postItem.id)) {
            return [...prev, postItem];
          }
          return prev;
        });
        break;

      case "cleaning":
        setCleaningPosts((prev) => {
          if (!prev.some((post) => post.id === postItem.id)) {
            return [...prev, postItem];
          }
          return prev;
        });
        break;

      default:
      // Handle cases where the category doesn't match any of the above
    }
  };

  useEffect(() => {
    posts.forEach((postItem) => {
      updatePostsByCategory(postItem);
    });
  }, [categoryValue]);
  return (
    <div>
      <Main
        key={category}
        posts={eval(`${categoryValue}Posts`)}
        cat={category}
      />
    </div>
  );
}

export default ArticleList;
